$(document).ready(function () {
  $(".customer_blocks").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    adaptiveHeight: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left btn-left-color'><img width='30px' class='arrow-left-color' src='https://cdn.shopify.com/s/files/1/0764/8568/9650/files/arrow-left_4.png?v=1690364086'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right btn-right-color'><img width='30px' class='arrow-right-color' src='https://cdn.shopify.com/s/files/1/0764/8568/9650/files/arrow-right_3.png?v=1690363862'/></button>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".announcement-slider").slick({
    swipeToSlide: true,
    slidesToShow: 3,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 899,
        settings: {
          autoplay: true,
          autoplaySpeed: 2000,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  });

  $(".custom-col-grid").slick({
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    slidesToShow: 3,
    draggable: true,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  });
  $("#recently-viewed-products .grid__item").slick({
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    slidesToShow: 4,
    draggable: true,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 899,
        settings: {
          draggable: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          infinite: true,
        },
      },
    ],
  });
  $(".logo-bar").slick({
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    slidesToShow: 4,
    draggable: true,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 899,
        settings: {
          draggable: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          infinite: true,
        },
      },
    ],
  });
});
